import { VectorLabApp } from './VectorLabApp';
import { GaiaWidget } from './GaiaWidget';

class Main {
    private app: VectorLabApp;

    constructor() {
        this.app = new VectorLabApp();
        new GaiaWidget();
    }

    public init(): void {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.start();
            });
        } else {
            this.start();
        }
    }

    private start(): void {
        try {
            this.app.init();
            console.log('Vector Lab started successfully');
        } catch (error) {
            console.error('Failed to start Vector Lab:', error);
        }
    }

    public destroy(): void {
        this.app.destroy();
    }
}

const main = new Main();
main.init();

window.addEventListener('beforeunload', () => {
    main.destroy();
});
